import { SliderManager } from './slider-manager';
import { SliderManagerProvider } from './slider-manager.provider';

export const FeatureSliderManager = () => {
   return (
      <SliderManagerProvider>
         <SliderManager></SliderManager>
      </SliderManagerProvider>
   );
};
